import {
  useMutation,
  type MutationHookOptions,
  type MutationTuple,
  type TypedDocumentNode,
} from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdatePlaylistTagsDocument } from './update.generated';

const useUpdate = <T, U>(
  document: TypedDocumentNode<T, U>,
  options: MutationHookOptions<T, U>,
): MutationTuple<T, U> => {
  const { t } = useTranslation();

  return useMutation(document, {
    ...useNotifications(document, {
      failure: t('api.playlist_tags.update_error'),
      success: t('api.playlist_tags.update_success'),
    }),
    ...options,
  });
};

export const useUpdatePlaylistTags = (
  options: ApiOptions<typeof UpdatePlaylistTagsDocument> = {},
) => useUpdate(UpdatePlaylistTagsDocument, options);
